import React from "react";
import cx from "classnames";

export const showToast = (containerId, toastStatus) => {
  const toast = document.getElementById(
    `${containerId}__toast--${toastStatus}`
  ).classList;
  toast.add("show");
  setTimeout(() => {
    toast.remove("show");
  }, 3000);
};

const Toast = ({ containerId, toastStatus, header, description }) => (
  <div className="toast-wrapper" aria-live="polite" aria-atomic="true">
    <div
      id={`${containerId}__toast--${toastStatus}`}
      className="toast"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className={cx("toast-body", toastStatus)}>
        <strong className="mr-auto">{header}</strong>
        <p className="mb-0">{description}</p>
      </div>
    </div>
  </div>
);

export default Toast;
